import { AdminReportConfiguration } from '@Containers/Report';

const AdminReportPage: React.FC = () => <AdminReportConfiguration />;

export default AdminReportPage;
